import { Button, UIText1, Image } from '@cian/ui-kit';
import * as React from 'react';

import StopSubscription from './assets/StopSubscription.png';
import * as styles from './index.css';

export interface IUnsubscribeErrorProps {
  error: string;
  onClick(): void;
}

export const UnsubscribeError: React.FC<IUnsubscribeErrorProps> = ({ error, onClick }) => (
  <div className={styles['container']}>
    <Image src={StopSubscription} objectFit="cover" width="100px" height="100px" />
    <div className={styles['description']}>
      <UIText1 color="black_100">{error}</UIText1>
    </div>
    <Button type="submit" theme="fill_primary" size="M" onClick={onClick}>
      Хорошо
    </Button>
  </div>
);
